var map = {
	"./Group 22302.png": 1312,
	"./avatar-christmas.webp": 1313,
	"./bottom-bg-christmas.webp": 1314,
	"./btn-active.png": 1315,
	"./content-deco-1.webp": 1316,
	"./content-deco-2.webp": 1317,
	"./content-deco-3.webp": 1318,
	"./content-deco-4.webp": 1319,
	"./deco-3.webp": 1320,
	"./deposit-icon.webp": 1321,
	"./home-icon-active.webp": 1322,
	"./home-icon.webp": 1323,
	"./live-icon-active.webp": 1324,
	"./live-icon.webp": 1325,
	"./master-bg.jpg": 1326,
	"./me-icon-active.webp": 1327,
	"./me-icon.webp": 1328,
	"./platform.png": 1329,
	"./platform.webp": 1330,
	"./promos-icon-active.webp": 1331,
	"./promos-icon.webp": 1332,
	"./promos.webp": 1333,
	"./service-christmas.webp": 1334,
	"./snowman.webp": 1335,
	"./sponsor-icon-active.webp": 1336,
	"./sponsor-icon.webp": 1337,
	"./title-deco-left.webp": 1338,
	"./title-deco-right.webp": 1339,
	"./tree.webp": 1340,
	"./vip-icon.webp": 1341,
	"./vip.webp": 1342,
	"./withdraw-icon.webp": 1343,
	"./wwr-img.webp": 1344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;